import { useCallback } from "react";

const NAVBAR_OFFSET = 100;

const SECTION_OFFSETS: Record<string, number> = {
  projects: -80,
};

const useScrollToSection = () => {
  const scrollToSection = useCallback((sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      const extraOffset = SECTION_OFFSETS[sectionId] ?? 0;
      const top = section.getBoundingClientRect().top + window.scrollY - NAVBAR_OFFSET - extraOffset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  }, []);

  return scrollToSection;
};

export default useScrollToSection;
